import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { Swiper, SwiperSlide } from 'swiper/react';
import { logEvent } from 'firebase/analytics';

import { boardDetail, programBoardList } from '@/network/apis/apiUri';
import useContent from '@/localization/data_export';
import analytics from '@/routes/firebase';
import VideoThumbnail from '@/components/video-thumnail';

export default function EditorPickYoutube() {
  const { mode } = useSelector((state) => state);

  const anchorTitle = useContent(['global', 'anchor', 'title']);

  const observerRef = useRef();
  const [isVisible, setIsVisible] = useState(false);

  const { isSuccess, data } = useQuery(
    ['main', 'editor-pick', 'episode', 981],
    async () => {
      const boardResponse = await programBoardList({
        lan_code: mode,
        board_id: 981,
        board_item_type: 'episode',
        title: '',
        content_category: '',
        event_category: null,
        is_open_allow: true,
        is_blind_allow: false,
        hit: true,
        page_info: { row_count: 20, number: 0 },
      });

      const detailResponse = await boardDetail({ board_id: 981 });
      const detailData = detailResponse.data;

      return {
        title: detailData.title.find((v) => v.lan_code === mode).text,
        content: detailData.content.find((v) => v.lan_code === mode).text,
        items: boardResponse.data.item.map((item) => ({
          id: item.board_item_id,
          title: item.title,
          image: item.episodes[0].image_url,
          link: `/vod/view?id=${item.episodes[0].episode_id}&board=${item.board_id}&sort=reco`,
          broadcast: item.episodes[0].broadcast_date.slice(0, 10),
          duration: item.episodes[0].duration,
        })),
      };
    },
    {
      retry: false,
      staleTime: 1000 * 60 * 3,
      enabled: !!mode,
    }
  );

  useEffect(() => {
    let observe = null;

    if (!isVisible && observerRef.current) {
      observe = new IntersectionObserver(([entry], observer) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      });

      observe.observe(observerRef.current);
    }
    return () => {
      if (observe) observe.disconnect();
    };
  }, []);

  const isComplete = isSuccess && isVisible && data.items.length > 0;

  return (
    <div ref={observerRef} data-has-item={isComplete}>
      {isComplete && (
        <div>
          <div className="pick-title">
            <h2>{data.title}</h2>
            <p>{data.content}</p>
          </div>
          <div className="pick-slide">
            <Swiper slidesPerView={5} spaceBetween={25} navigation>
              {data.items.map((item) => (
                <SwiperSlide key={item.id}>
                  <Link
                    to={item.link}
                    title={anchorTitle}
                    onClick={() =>
                      logEvent(analytics, 'select_item', {
                        item_list_name: `${item.title}`,
                        item_list_id: `episode_${item.id}`,
                        items: [
                          {
                            item_id: `${item.id}`,
                            item_name: `${item.title}`,
                            item_brand: 'episode',
                          },
                        ],
                      })
                    }
                  >
                    <div className="image-container">
                      <VideoThumbnail thumbnail={item.image} duration={item.duration} />
                    </div>
                    <p>{item.title}</p>
                    <time className="time-fs-fixed">{item.broadcast}</time>
                  </Link>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      )}
    </div>
  );
}
